"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _r10CommonComponents = require("r10-common-components");
var _r10SourceLibrary = require("r10-source-library");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useProps3 = _interopRequireDefault(require("../../hooks/useProps"));
var _useConfig3 = _interopRequireDefault(require("../../hooks/useConfig"));
var _useTranslation = _interopRequireDefault(require("../../hooks/useTranslation"));
var _selector = require("../../selectors/selector");
var _extractAddonsData = _interopRequireDefault(require("../../utils/extractAddonsData"));
var _iconsLookup = _interopRequireDefault(require("../../constants/icons-lookup"));
var _unitsLookup = _interopRequireDefault(require("../../constants/units-lookup"));
var _reactRouterDom = require("react-router-dom");
var _enjoyMore = _interopRequireDefault(require("../../utils/enjoyMore"));
var _removeDuplicates = _interopRequireDefault(require("../../utils/removeDuplicates"));
var _completeCategoryPriorities = _interopRequireDefault(require("../../utils/completeCategoryPriorities"));
var _BuyAddonModal = _interopRequireDefault(require("../BuyAddonModal"));
var _Actions = require("../../actions/Actions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var EligibleAddonsListing = function EligibleAddonsListing(_ref) {
  var selectedFilters = _ref.selectedFilters;
  var history = (0, _reactRouterDom.useHistory)();
  var t = (0, _useTranslation.default)();
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useProps = (0, _useProps3.default)(),
    language = _useProps.language;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isBuyAddonModalOpen = _useState2[0],
    setIsBuyAddonModalOpen = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedAddon = _useState4[0],
    setSelectedAddon = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    autoRenewToggle = _useState6[0],
    setAutoRenewToggle = _useState6[1];
  var addonsRef = (0, _react.useRef)();
  var _useProps2 = (0, _useProps3.default)(),
    eligibleAddonKeys = _useProps2.eligibleAddonCardMappingConfiguration;
  var _useConfig = (0, _useConfig3.default)(),
    detailsPageURL = _useConfig.detailsPageURL,
    _useConfig$inclusionI = _useConfig.inclusionIcons,
    inclusionIcons = _useConfig$inclusionI === void 0 ? [] : _useConfig$inclusionI;
  var _useConfig2 = (0, _useConfig3.default)(),
    _useConfig2$categorie = _useConfig2.categoriesPriority,
    categoriesPriority = _useConfig2$categorie === void 0 ? [] : _useConfig2$categorie,
    socialAppsPriority = _useConfig2.socialAppsPriority;
  var categoryIcons = {};
  categoriesPriority.forEach(function (cat) {
    categoryIcons = _objectSpread(_objectSpread({}, categoryIcons), {}, _defineProperty({}, cat.name, cat.icon));
  });
  var eligibleAddonsData = (0, _reactRedux.useSelector)(_selector.eligibleAddons);
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    filteredAddons = _useState8[0],
    setFilteredAddons = _useState8[1];
  var buyAddonHandler = function buyAddonHandler(id, state) {
    var _selectedAddon$price;
    var selectedAddon = addonsRef.current.find(function (addon) {
      return addon.id === id;
    });
    dispatch((0, _Actions.sendTags)({
      taggingId: 'CUSTOMER_DASHBOARD_ADDONS_4',
      taggingType: 'link',
      taggingValue: {
        event_value: selectedAddon === null || selectedAddon === void 0 ? void 0 : selectedAddon.name,
        product_id: selectedAddon === null || selectedAddon === void 0 ? void 0 : selectedAddon.id,
        product_name: selectedAddon === null || selectedAddon === void 0 ? void 0 : selectedAddon.name,
        product_price: selectedAddon === null || selectedAddon === void 0 || (_selectedAddon$price = selectedAddon.price) === null || _selectedAddon$price === void 0 || (_selectedAddon$price = _selectedAddon$price.price) === null || _selectedAddon$price === void 0 ? void 0 : _selectedAddon$price.value
      }
    }));
    setAutoRenewToggle(state);
    setSelectedAddon(selectedAddon || {});
    setIsBuyAddonModalOpen(true);
  };
  var onChangeToggleHandler = function onChangeToggleHandler(id, state) {
    var hasMoreThanOneType = addonsRef.current.find(function (addon) {
      return addon.id === id;
    }).renewAndValidity.addonTypes.length > 1;
    history.push(_objectSpread({
      pathname: "".concat(detailsPageURL, "/").concat(id)
    }, hasMoreThanOneType ? {
      search: "?auto-renew=".concat(state)
    } : {}));
  };
  var getTopFeaturesText = function getTopFeaturesText(value, unitOfMeasure, feature) {
    var formattedValue = feature.toLowerCase().includes('data') ? _r10CommonComponents.utils.formatMB(value) : "".concat(value, " ").concat(t(_unitsLookup.default[unitOfMeasure.toLowerCase()]));
    return "".concat(value == -1 ? t('unlimited') : formattedValue);
  };
  var formatAddons = function formatAddons(addons) {
    return addons.map(function (addon) {
      var _addon$category, _addon$category2, _addon$price;
      var apps = addon.servicesIncluded.length ? {
        servicesIncluded: _objectSpread({
          distanceBetweenIcons: 16,
          iconsWidth: 30,
          iconsHeight: 30,
          paddingTop: 0,
          paddingBottom: 20,
          justify: 'flex-start'
        }, (0, _enjoyMore.default)(addon.servicesIncluded, t))
      } : {};
      return _objectSpread(_objectSpread({
        id: addon.id,
        category: addon.category,
        cardHeader: {
          icon: {
            name: _iconsLookup.default[categoryIcons[(_addon$category = addon.category) === null || _addon$category === void 0 ? void 0 : _addon$category.toLowerCase()]] || _iconsLookup.default[(_addon$category2 = addon.category) === null || _addon$category2 === void 0 ? void 0 : _addon$category2.toLowerCase()] || 'add-ons',
            group: 'system'
          },
          minHeight: 132,
          header: addon.name,
          iconSize: 3,
          headerLevel: 2,
          distanceBetweenIconAndHeader: 12
        },
        cardBody: {
          distanceBetweenItemsAndIcons: 8,
          distanceBetweenItems: 8,
          iconSize: 2,
          items: addon.topFeatures.map(function (_ref2) {
            var iconName = _ref2.iconName,
              feature = _ref2.feature,
              value = _ref2.value,
              unitOfMeasure = _ref2.unitOfMeasure;
            return {
              icon: {
                name: iconName,
                group: 'system'
              },
              text: t(feature, {
                value: getTopFeaturesText(value, unitOfMeasure, feature)
              })
            };
          })
        }
      }, apps), {}, {
        priceOffering: {
          prefixText: "".concat(t('price'), ":"),
          price: (_addon$price = addon.price) === null || _addon$price === void 0 ? void 0 : _addon$price.formattedPrice
        },
        tileButton: {
          buttonText: t('buyNow'),
          showButton: true,
          id: addon.id,
          linkText: t('details'),
          showLink: true,
          onClick: function onClick(id, state) {
            return buyAddonHandler(id, state);
          },
          onClickLink: function onClickLink(id, state) {
            return onChangeToggleHandler(id, state);
          }
        },
        renewAndValidity: {
          typeLabel: "".concat(t('addonTypeLabel'), ": "),
          type: t(addon.renewAndValidity.text),
          date: {
            iconName: 'calendar-month',
            iconSize: 3,
            text: "".concat(t('duration'), " ").concat(addon.duration)
          },
          autoRenew: addon.renewAndValidity.showToggleButton && {
            iconName: 'refresh',
            iconSize: 3,
            text: t('autoRenewal'),
            isActive: false
          },
          showAutoRenew: true
        }
      });
    });
  };
  (0, _react.useEffect)(function () {
    var _Object$values;
    if (!Object.keys(eligibleAddonsData.addons).length) return;
    var categoriesPriorities = (0, _completeCategoryPriorities.default)(eligibleAddonsData.addons.subCategory, categoriesPriority);
    if (selectedFilters.length) categoriesPriorities = categoriesPriorities.filter(function (cat) {
      return selectedFilters.filter(function (filter) {
        return filter === cat.name;
      })[0];
    });
    var uniqueAddons = (0, _removeDuplicates.default)(eligibleAddonsData.addons.subCategory, categoriesPriorities);
    var manipulation = new _extractAddonsData.default({
      subCategory: uniqueAddons
    }, eligibleAddonKeys, socialAppsPriority, inclusionIcons);
    var categorizedAddons = manipulation.getCategoriesAndItsAddons();
    addonsRef.current = (_Object$values = Object.values(categorizedAddons)) === null || _Object$values === void 0 ? void 0 : _Object$values.flat();
    var addons = formatAddons(Object.values(categorizedAddons).flat());
    setFilteredAddons(addons);
  }, [eligibleAddonsData, selectedFilters, language]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !!filteredAddons && /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "filtered-addons-list"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    verticalAlign: "stretch",
    justify: "left",
    spacing: 4
  }, filteredAddons.map(function (addon) {
    return /*#__PURE__*/_react.default.createElement(_r10CommonComponents.AddonCard, _extends({
      key: addon.id
    }, addon));
  })), /*#__PURE__*/_react.default.createElement(_BuyAddonModal.default, {
    isModalOpen: isBuyAddonModalOpen,
    setIsModalOpen: setIsBuyAddonModalOpen,
    bundleDetails: selectedAddon,
    autoRenew: autoRenewToggle
  })));
};
EligibleAddonsListing.propTypes = {
  selectedFilters: _propTypes.default.array
};
var _default = EligibleAddonsListing;
exports.default = _default;